/**
 * 008-reporting-dashboards T019 (FR-012, D-29). Column sets for `Collisions.tsx` — one for the
 * overlapping pairs, one for the SKUs the report could not check (excluded, never dropped).
 */
import type { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import { formatQty } from "../../lib/services/warehouse";
import type { CollisionPair, CollisionCandidate } from "../../lib/services/warehouse";
import { inventoryPath } from "../../lib/paths";

export const collisionPairColumns: ColumnDef<CollisionPair>[] = [
  {
    id: "skuA",
    accessorKey: "skuAName",
    header: "SKU A",
    cell: ({ row }) => (
      <Link to={inventoryPath(row.original.skuAId)} className="hover:underline">
        {row.original.skuAName}
      </Link>
    ),
  },
  {
    id: "skuAWeight",
    accessorFn: (row) => Number(row.skuAExpectedWeight),
    header: "Expected weight A",
    meta: { align: "right" },
    cell: ({ row }) => <span className="block text-right tabular-nums">{formatQty(row.original.skuAExpectedWeight)} kg</span>,
  },
  {
    id: "skuB",
    accessorKey: "skuBName",
    header: "SKU B",
    cell: ({ row }) => (
      <Link to={inventoryPath(row.original.skuBId)} className="hover:underline">
        {row.original.skuBName}
      </Link>
    ),
  },
  {
    id: "skuBWeight",
    accessorFn: (row) => Number(row.skuBExpectedWeight),
    header: "Expected weight B",
    meta: { align: "right" },
    cell: ({ row }) => <span className="block text-right tabular-nums">{formatQty(row.original.skuBExpectedWeight)} kg</span>,
  },
  {
    id: "overlapKg",
    accessorFn: (row) => Number(row.overlapKg),
    header: "Overlap",
    meta: { align: "right" },
    cell: ({ row }) => <span className="block text-right font-medium tabular-nums">{formatQty(row.original.overlapKg)} kg</span>,
  },
];

export const collisionExcludedColumns: ColumnDef<CollisionCandidate>[] = [
  {
    id: "sku",
    accessorFn: (row) => row.skuName ?? "",
    header: "SKU",
    cell: ({ row }) =>
      row.original.skuId ? (
        <Link to={inventoryPath(row.original.skuId)} className="hover:underline">
          {row.original.skuName ?? "—"}
        </Link>
      ) : (
        row.original.skuName ?? "—"
      ),
  },
  {
    id: "expectedWeight",
    accessorFn: (row) => (row.expectedWeight ? Number(row.expectedWeight) : undefined),
    sortUndefined: "last",
    header: "Expected weight",
    meta: { align: "right" },
    cell: ({ row }) => <span className="block text-right tabular-nums">{row.original.expectedWeight ? `${formatQty(row.original.expectedWeight)} kg` : "—"}</span>,
  },  {
    id: "rule",
    accessorFn: (row) => row.tolerance.ruleLabel ?? "",
    header: "Tolerance rule",
    cell: ({ row }) => row.original.tolerance.ruleLabel ?? "—",
  },
];
